import { render } from "./contentCategoryOverviewItemGridCard.vue?vue&type=template&id=08c2e2ba&scoped=true&ts=true"
import script from "./contentCategoryOverviewItemGridCard.vue?vue&type=script&lang=ts"
export * from "./contentCategoryOverviewItemGridCard.vue?vue&type=script&lang=ts"

import "./contentCategoryOverviewItemGridCard.vue?vue&type=style&index=0&id=08c2e2ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c2e2ba"]])

export default __exports__